import { motion } from "framer-motion";

interface Props {
  onSearch: (query: string) => void;
  items?: string[];
}

const DEFAULT_ITEMS = [
  "Best monitor under $500",
  "Best chair for back pain",
  "Best vacuum under $400",
];

export default function SuggestionChips({ onSearch, items }: Props) {
  const displayed = items && items.length > 0 ? items : DEFAULT_ITEMS;

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.35 }}
      className="mt-4 sm:mt-5 w-full max-w-md mx-auto overflow-hidden"
    >
      <div className="flex gap-2 flex-wrap justify-center px-1">
        {displayed.map((s) => (
          <button
            key={s}
            onClick={() => onSearch(s)}
            className="rounded-full px-3.5 py-1.5 bg-muted/30 border border-border/40 text-[12.5px] font-body text-muted-foreground hover:text-foreground hover:bg-muted/50 hover:border-border/60 transition-colors"
          >
            {s}
          </button>
        ))}
      </div>
    </motion.div>
  );
}
